import { PGImageDimensions } from '../../../lib/propertyTypes';

export const pickMediaURLs = (images: PGImageDimensions[]): string[] => {
  return images.map((image: { V800: string }) => image.V800);
};
